import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Pack de Scripts WhatsApp',
  subtitle: 'Bono 1',
  desc: 'Mensajes listos para responder consultas, enviar condiciones, cerrar reservas y comunicarte con más claridad.',
  image: 'https://cdn.magicpatterns.com/uploads/5xGp6Tm4aKFXdQhe98iHEF/bono_1.png'
}, {
  title: 'Fichero Técnico de Clientas',
  subtitle: 'Bono 2',
  desc: 'Una herramienta para registrar información clave, seguimiento y detalles importantes de cada servicio.',
  image: 'https://cdn.magicpatterns.com/uploads/wuLM6mUzaPGSs4gpViXk2X/bono_2.png'
}, {
  title: 'Checklist Operativo Diario',
  subtitle: 'Bono 3',
  desc: 'Tu guía práctica para mantener orden antes, durante y después de cada jornada.',
  image: 'https://cdn.magicpatterns.com/uploads/ku7iWDjMK3CcidYsAgfLyN/bono_3.png'
}, {
  title: 'Kit de Políticas Profesionales',
  subtitle: 'Bono 4',
  desc: 'Textos y estructura para comunicar señas, cancelaciones, horarios, llegadas tarde y condiciones del servicio.',
  image: 'https://cdn.magicpatterns.com/uploads/hhP2JGe8SoPefrrcj1UCRK/bono_4.png'
}, {
  title: 'Planner Semanal de Control del Negocio',
  subtitle: 'Bono 5',
  desc: 'Una vista simple para organizar tareas, turnos, prioridades y seguimiento semanal.',
  image: 'https://cdn.magicpatterns.com/uploads/5nJrusPk46VL3sLsstjQub/bono_5.png'
}, {
  title: 'Pack de Hojas Manuales para Costos y Precios',
  subtitle: 'Bono 6',
  desc: 'Plantillas para ayudarte a calcular mejor y dejar de tomar decisiones a ojo.',
  image: 'https://cdn.magicpatterns.com/uploads/7FmNHPiv2nrNjN9uvm9FsM/bono_6.png'
}];
export function Bonuses() {
  return <section className="py-20 bg-white pt-[30px] pb-[30px]" data-id="element-11">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-14">
            6 bonos operativos incluidos
          </h2>
          <p className="text-lg text-gray-600" data-id="element-15">
            Herramientas listas para aplicar en tu negocio desde el día 1.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-16">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-ocean-cream rounded-3xl border border-gray-100 shadow-sm overflow-hidden flex flex-col" data-id="element-17">
              {bonus.image ? <div className="w-full aspect-square overflow-hidden" data-id="element-18">
                  <img src={bonus.image} alt={`${bonus.subtitle} - ${bonus.title}`} className="w-full h-full object-cover" data-id="element-19" />
                </div> : <div className="w-full aspect-square bg-white border border-dashed border-gray-200 flex items-center justify-center" data-id="element-20">
                  <Gift className="w-12 h-12 text-gray-300" data-id="element-21" />
                </div>}
              <div className="p-6 flex-1 flex flex-col" data-id="element-22">
                <div className="text-sm font-bold uppercase tracking-wider mb-1 text-ocean-teal" data-id="element-23">
                  {bonus.subtitle}
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-25">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}